<template>
	<div
		class="mx-2 bg-gray-600 md:rounded-b-2xl px-4 py-4"
		v-if="showSearch || filter.search !== ''"
	>
		<div
			class="bg-gray-700 w-full flex items-center relative rounded-md shadow-sm"
		>
			<div
				class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400"
			>
				<ui-icon
					class="xl:mr-4 flex-shrink-0 h-5 w-5"
					name="search"
					stroke-width="2"
				/>
			</div>

			<input
				type="text"
				v-model="filter.search"
				v-on:keyup="filter.search = $event.target.value"
				class="pl-10 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md"
				placeholder
			/>

			<div class="absolute inset-y-0 right-0 flex items-center">
				<label for="currency" class="sr-only">close search</label>
				<button
					class="px-4 text-gray-400"
					v-on:click.stop="
						filter.search = '';
						showSearch = !showSearch;
					"
				>
					<ui-icon class="w-5 h-5" name="x" stroke-width="2" />
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		filter: {
			type: Object,
			required: true,
		},
		showSearch: {
			type: Boolean,
			required: false,
		},
	},
};
</script>
